const HOT_LIST = [
  { rank: 1, tag: "联动", text: "影综双栖主演直播互cue，评论区当场炸锅", heat: "128万" },
  { rank: 2, tag: "串门", text: "老牌综艺老友回归路透，行程表疑被扒出", heat: "96万" },
  { rank: 3, tag: "跨圈", text: "剧粉与舞台粉因节目站位掀起讨论，后援会发文", heat: "81万" },
  { rank: 4, tag: "圈外", text: "音乐厂牌新人疑跨界客串电影，片场照流出", heat: "74万" },
  { rank: 5, tag: "联动", text: "双导演接力执导话题剧，幕后花絮释出", heat: "63万" },
];

const STORY_TAGS = ["联动", "跨界", "串门", "后续"];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pt-24 md:pt-28">
      <div
        className="pointer-events-none absolute inset-0 opacity-60"
        style={{
          backgroundImage:
            "radial-gradient(circle at 12% 18%, oklch(var(--primary-100)/0.7) 0, transparent 30%), radial-gradient(circle at 88% 12%, oklch(var(--accent-100)/0.6) 0, transparent 32%)",
        }}
      />
      <div className="container-x relative">
        <div className="flex flex-col gap-8 py-8 md:py-12 lg:flex-row lg:gap-10">
          {/* featured */}
          <article className="flex-1 overflow-hidden rounded-3xl border border-background-200 bg-background-50">
            <div className="relative h-[220px] w-full overflow-hidden md:h-[300px]">
              <img
                src="https://readdy.ai/api/search-image?query=Theater%20stage%20with%20warm%20spotlight%20lighting%2C%20red%20curtain%2C%20audience%20silhouette%20in%20foreground%2C%20editorial%20backstage%20photography%20with%20warm%20amber%20and%20cool%20red%20tones%2C%20cinematic%20lighting%2C%20modern%20entertainment%20venue&width=1200&height=700&seq=chigua-hero-2026&orientation=landscape"
                alt="剧场舞台灯光下跨圈联动的气氛"
                className="h-full w-full object-cover"
              />
              <div className="absolute left-4 top-4 flex flex-wrap gap-2">
                {STORY_TAGS.map((t) => (
                  <span
                    key={t}
                    className="whitespace-nowrap rounded-full bg-background-50/90 px-3 py-1 text-xs text-foreground-700"
                  >
                    #{t}
                  </span>
                ))}
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent px-5 pb-4 pt-10 md:px-6">
                <p className="text-xs text-background-200">今日热瓜 · 联动追踪</p>
                <h2 className="mt-1 font-display text-xl leading-snug text-background-50 md:text-2xl">
                  当红剧集双主演官宣再度联动，跨圈串门新料一条线理清
                </h2>
              </div>
            </div>
            <div className="flex items-center gap-3 px-5 py-4 md:px-6">
              <span className="whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs text-background-50">
                持续更新
              </span>
              <p className="line-clamp-2 flex-1 text-sm text-foreground-600">
                从首次同框到幕后互动，这段跨圈瓜的来路与影响已被小编逐条整理，点击进入围观完整时间线。
              </p>
              <a
                href="#lian"
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-background-100 text-primary-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                aria-label="查看完整时间线"
              >
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </article>

          {/* hot list */}
          <aside className="w-full lg:w-[360px]">
            <div className="rounded-3xl border border-background-200 bg-background-100/60 p-5 md:p-6">
              <div className="mb-4 flex items-center justify-between">
                <h2 className="flex items-center gap-2 font-display text-lg text-foreground-900">
                  <i className="ri-fire-line text-accent-500" />
                  实时热瓜榜
                </h2>
                <a href="#lian" className="text-xs text-primary-600 hover:text-primary-700">
                  换一批
                </a>
              </div>
              <ol className="space-y-1">
                {HOT_LIST.map((item) => (
                  <li key={item.rank}>
                    <a
                      href="#lian"
                      className="group flex items-center gap-3 rounded-xl px-2 py-2.5 transition-colors hover:bg-background-50"
                    >
                      <span
                        className={`font-display text-lg ${
                          item.rank <= 3 ? "text-accent-500" : "text-foreground-400"
                        }`}
                      >
                        {String(item.rank).padStart(2, "0")}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block truncate text-sm text-foreground-800 group-hover:text-primary-600">
                          {item.text}
                        </span>
                      </span>
                      <span className="flex shrink-0 flex-col items-end gap-0.5">
                        <span className="whitespace-nowrap rounded bg-accent-100 px-1.5 py-0.5 text-[10px] text-accent-700">
                          {item.tag}
                        </span>
                        <span className="text-[11px] text-foreground-400">{item.heat}</span>
                      </span>
                    </a>
                  </li>
                ))}
              </ol>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}